export const infiniteScrollDetect = async (selector = '#more-elements') => {
    const infiniteScrollPixel = document.querySelector(selector);
    if (infiniteScrollPixel) {
        const infinite = await import('./infiniteScrolling');
        infinite.infiniteScroller(infiniteScrollPixel);
    }
}